module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0886.4d9c5070.jpg";